import { render } from "./SignatureComponent.vue?vue&type=template&id=2563529c&ts=true"
import script from "./SignatureComponent.vue?vue&type=script&lang=ts"
export * from "./SignatureComponent.vue?vue&type=script&lang=ts"

import "./SignatureComponent.vue?vue&type=style&index=0&id=2563529c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__